


import { useMemo } from "react";

import { Box, Stack } from "@mui/system";
import { LoadingButton } from "@mui/lab";
import { Alert, Button, Typography } from "@mui/material";

import { useBoolean } from "src/hooks/use-boolean";
import { useAuthContext } from "src/hooks/auth/use-auth-context";

import { useTranslate } from "src/locales";
import { useUpdateOnboardingContextMutation } from "src/services/account/account.service";

import PhoneSetupModal from "./phone-setup-modal";

export default function PhoneSetupAlert() {

  const { t } = useTranslate();

  const authContext = useAuthContext();

  const verifyPhoneModalControl = useBoolean();

  const [updateOnboardingStatus, { isLoading: isSkipping }] = useUpdateOnboardingContextMutation();

  const shouldShowAlert = useMemo(() => {
    if (!authContext) return false;

    if (!authContext.account.onboarding_context?.phone_setup && !authContext.user.phone_verified) {
      return true;
    }

    return false;

  }, [authContext]);

  const onSkipSetup = async () => {
    updateOnboardingStatus({
      phone_setup: true,
    });
  }

  const onVerifyPhone = () => {
    verifyPhoneModalControl.onTrue();
  }

  const onPhoneVerified = () => {
    verifyPhoneModalControl.onFalse();
    updateOnboardingStatus({
      phone_setup: true,
    });
  }

  if (!shouldShowAlert) return null;

  return (
    <Box sx={{ width: '100%', p: .5 }}>
      <Alert severity='info' sx={{ mb: 2, width: "100%" }}>
        <Stack direction="column" alignItems='start' gap={2}>
          <Stack direction='row' alignItems='center' justifyContent="space-between" sx={{ overflow: 'hidden', width: '100%' }}>
            <Stack direction='column' gap={0} alignItems='start'>
              <Typography variant='subtitle2'>
                {t('account.phone_setup.alert.title')}
              </Typography>
              <Typography variant='caption'>
                {t('account.phone_setup.alert.description')}
              </Typography>
            </Stack>
          </Stack>
          <Stack direction='row' spacing={1} alignItems='center' justifyContent="center">

            <Button
              variant="contained"
              size="small"
              onClick={onVerifyPhone}
            >
              {t('account.phone_setup.alert.actions.setup')}
            </Button>

            <LoadingButton
              loading={isSkipping}
              variant="outlined"
              size="small"
              sx={{ backgroundColor: 'white' }}
              onClick={onSkipSetup}
            >
              {t('account.phone_setup.alert.actions.skip')}
            </LoadingButton>
          </Stack>
        </Stack>

        {
          verifyPhoneModalControl.value && (
            <PhoneSetupModal open={verifyPhoneModalControl.value} onClose={verifyPhoneModalControl.onFalse} onSuccess={onPhoneVerified} />
          )
        }
      </Alert >
    </Box>
  )
}